import { Injectable } from "@angular/core";
import { IPendingTransaction } from "src/app/shared/interfaces/pending-transaction.interface";

@Injectable({providedIn: 'root'})
export class PendingTransactionsService {

    updateWithAbbreviatedDescriptions(pendingTransactions: IPendingTransaction[]): void {
        if (!pendingTransactions?.length) {
            return;
        }

        pendingTransactions.forEach(pendingTransaction => {
          this.updateSingleWithAbbreviatedDescription(pendingTransaction);
        });
    }

    updateSingleWithAbbreviatedDescription(pendingTransaction: IPendingTransaction): void {
        if (!pendingTransaction) return;

        pendingTransaction.description = pendingTransaction.description
           .replace('Picked Up', 'P/U')
           .replace('Completion of Partial Fill', 'Cmpltn of partial fill');
    }
}